import { PluginHelper } from "./PluginHelper";
import { logIssue } from "./layoutLogger";
export function computeCompletenessOfAttribute(cell, attributes) {
    const defaultResult = { isComplete: true };
    if (!PluginHelper.isAttributePlugin(cell)) {
        return defaultResult;
    }
    const props = PluginHelper.getPluginProps(cell);
    const attribute = attributes.find((attribute) => attribute.id === props.identifier);
    if (!attribute) {
        logIssue(`Attribute from not found in configuration state`, props.identifier);
        return defaultResult;
    }
    const isComplete = attribute.isComplete;
    // it does not matter if it is required or complete
    if (!attribute.isActive || !attribute.isVisible) {
        return { isComplete };
    }
    return { isComplete };
}
//# sourceMappingURL=computeCompletenessOfAttribute.js.map